import * as actionTypes from 'modules/audits/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/audits/constants';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {Array<string>} AuditDashboardIdsReducer
 * @type {AuditDashboardIdsReducer}
 */
const initialState = [];

/**
 * @param {AuditDashboardIdsReducer} state
 * @param {import('modules/audits/types/dashboard').FetchAuditsSuccessAction} action
 * @returns {AuditDashboardIdsReducer}
 */
const setIds = (state, { payload, meta }) => {
  if (meta?.source === DASHBOARD_SOURCE) {
    return [...state, ...payload.content.map(audit => audit.id)];
  }
  return state;
};

/**
 * @param {AuditDashboardIdsReducer} state
 * @param {import('modules/audits/types/details').PostAuditSuccessAction} action
 * @returns {AuditDashboardIdsReducer}
 */
const setId = (state, { payload: audit }) => [audit.id, ...state];

/**
 * @returns {AuditDashboardIdsReducer}
 */
const clearIds = () => initialState;

/**
 * @param {AuditDashboardIdsReducer} state
 * @param {import('modules/audits/types/dashboard').FetchAuditsAction} action
 * @returns {AuditDashboardIdsReducer}
 */
const auditsRequest = (state, { payload, meta }) => (meta?.source === DASHBOARD_SOURCE && !payload.request.params.page ? [] : state);

/**
 *
 * @param {AuditDashboardIdsReducer} state
 * @param {import('modules/audits/types/details').DeleteAuditSuccessAction} action
 * @returns {AuditDashboardIdsReducer}
 */
const deleteOne = (state, { payload: id }) => state.filter(auditId => auditId !== id);

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_REQUEST]: auditsRequest,
  [actionTypes.FETCH_AUDITS_SUCCESS]: setIds,
  [actionTypes.CLEAR_COLLECTION]: clearIds,
  [actionTypes.DELETE_SUCCESS]: deleteOne,
  [actionTypes.POST_SUCCESS]: setId,
  [actionTypes.POST_CLONE_SUCCESS]: setId,
});
